import { render } from "./CustomAutocompleteHorse.vue?vue&type=template&id=1bc621da"
import script from "./CustomAutocompleteHorse.vue?vue&type=script&lang=js"
export * from "./CustomAutocompleteHorse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__